import axios from 'axios';

const baseUrl = window.location.origin;

// ! May need to be https
// ! WILL NEED TO BE UPDATED IN STAGING / PROD
const api = axios.create({
  baseURL: `${baseUrl}/wp-json`,
  withCredentials: true // for cookie requests
});

// Attach token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// auto-refresh token on 403
api.interceptors.response.use(
  res => res,
  async error => {
    const original = error.config;
    if (error.response && error.response.status === 403 && !original._retry) {
      console.log('API: 403 error thrown');
      original._retry = true;
      const refresh = localStorage.getItem('refresh_token');
      // If we don't have a refresh token, we have to log in again
      // If we do, we have to validate it
      if (refresh) {
        console.log('API: We have a refresh token');
        try {
          const r = await axios.post(`${baseUrl}/wp-json/jwt-auth/v1/token/refresh`, {
            refresh_token: refresh
          });
          localStorage.setItem('access_token', r.data.token);
          original.headers.Authorization = `Bearer ${r.data.token}`;

          try {
            await axios.post(`${baseUrl}/wp-json/custom/v1/login-cookie`, {}, {
              headers: { Authorization: `Bearer ${r.data.token}` },
              withCredentials: true
            });
          } catch (cookieErr) {
            console.warn('API: cookie reissue failed, continuing anyway', cookieErr);
          }

          return axios.request(original);
        } catch (e) {
          // * set this to clear only specific localstorate out
          // * there are other localstorage things we need for notifications
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user');
          localStorage.removeItem('user_id');
        }
      }
      // Could place an else here
    }
    return Promise.reject(error);
  }
);

export default api;
